function collectText(value, parts = []) {

  if (
    value === undefined ||
    value === null
  ) {
    return parts;
  }

  if (Array.isArray(value)) {
    value.forEach(item =>
      collectText(item, parts)
    );

    return parts;
  }

  if (typeof value === 'object') {
    Object.entries(value).forEach(
      ([key, nestedValue]) => {
        parts.push(key);
        collectText(nestedValue, parts);
      }
    );

    return parts;
  }

  parts.push(String(value));

  return parts;
}

export function buildKeywords(job = {}) {

  const parts = [];

  collectText(
    [
      job.title,
      job.company,
      job.location,
      job.city,
      job.province,
      job.salary,
      job.hoursPerWeek,
      job.employmentType,
      job.workplaceType,
      job.type,
      job.postingDate,
      job.description,
      job.sections
    ],
    parts
  );

  const cleaned =
    parts
      .join(' ')
      .toLowerCase()
      .replace(/[^a-z0-9 ]/g, ' ');

  const words =
    cleaned
      .split(/\s+/)
      .filter(word => word.length > 2);

  return [...new Set(words)];
}
